import PropTypes from 'prop-types';


import {addressConstants} from '../Address';


// ------ shapes
export const SHAPE_BILLING_DATA = {
    additionalInvoiceText: PropTypes.string,
    address: addressConstants.SHAPE_ADDRESS,
    taxNumber: PropTypes.string
};

export const SHAPE_BILLING_DATA_LEGACY = {
    additionalInvoiceText: PropTypes.string,
    address: addressConstants.SHAPE_ADDRESS,
    taxNumber: PropTypes.string
};
